import React from 'react'

const RadioButton = ({id, active, setActive, handleResize}) => {
    return (
        <div 
            className="flex items-center"
            onClick={() => {setActive(id); handleResize()}}
            onKeyPress={() => {setActive(id); handleResize()}}
            role="radio"
            aria-checked
            tabIndex="0"
        >
            <input
                id={id}
                name="type"
                type="radio"
                checked={active === id ? true : false}
                className="peer focus:ring-transparent h-4 w-4 text-teal border-white focus:ring-offset-0"
            />
            <label htmlFor={id} className="ml-2 block text-sm font-semibold text-white tracking-[-0.01em] peer-checked:text-teal capitalize">
                {id}
            </label>
        </div>
    )
}

export default RadioButton